import React from "react";
type SectionLabelProps = {
  children: React.ReactNode;
  tone?: "muted" | "accent" | "inverse";
  className?: string;
};
export function SectionLabel({
  children,
  tone = "accent",
  className = ""
}: SectionLabelProps) {
  const color = tone === "accent" ? "text-oxblood" : tone === "inverse" ? "text-ivory/75" : "text-charcoal/70";
  return <p className={`eyebrow ${color} ${className}`} data-id="element-581" data-mp="33e5nbjky61lx">{children}</p>;
}